import { render, staticRenderFns } from "./date.vue?vue&type=template&id=bfa26d1e&scoped=true&"
import script from "./date.vue?vue&type=script&lang=ts&"
export * from "./date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa26d1e",
  null
  
)

export default component.exports